import { Eye, EyeOff } from 'lucide-react'
import { ToolbarButton } from './ToolbarButton'

interface SidebarToggleButtonProps {
	isVisible: boolean
	onToggle: () => void
}

/**
 * Sidebar visibility toggle. Shows EyeOff when panel is visible
 * (action icon = "click to hide"), Eye when hidden.
 */
export function SidebarToggleButton({ isVisible, onToggle }: SidebarToggleButtonProps) {
	return (
		<ToolbarButton
			icon={isVisible ? EyeOff : Eye}
			tooltip={isVisible ? 'Hide Side Bar' : 'Show Side Bar'}
			onClick={onToggle}
		/>
	)
}
